<template>
  <b-modal
    id="modal-nuevo-pago"
    centered
    title="Nuevo Pago"
    ok-title="GUARDAR"
    cancel-title="CANCELAR"
    cancel-variant="outline-secondary"
    v-model="$store.state.someVariables.showNewPago"
    no-close-on-backdrop
    size="lg"
  >
    <b-row>
      <b-col md="5">
        <b-form>
          <div class="form-label-group">
            <b-form-input
              id="floating-titulo"
              placeholder="Ingrese Valor *"
              v-model="dataPago.valor"
              type="number"
              class="mt-1"
            />
            <label for="floating-titulo">Valor</label>
          </div>
          <div class="form-label-group">
            <b-form-input
              id="floating-link"
              placeholder="Ingrese Banco y #comprobante"
              v-model="dataPago.comprobante"
              class="mt-2"
            />
            <label for="floating-link">Banco-#Comprobante</label>
          </div>
          <label for="textarea-default">Observación</label>
          <b-form-textarea
            v-model="dataPago.descripcion"
            id="textarea-default"
            placeholder="Observación"
            rows="3"
          />
        </b-form>
        <b-form-group class="mt-1">
          <span style="font-size:12px">
            Fecha Pago
          </span>
          <flat-pickr v-model="dataPago.fecha" class="form-control" />
        </b-form-group>
        <v-select
          placeholder="Seleccionar Responsable"
          :clearable="true"
          taggable
          :options="listResponsables"
          v-model="dataPago.responsable"
          class="mb-1 mt-1 select-size-sm"
        />
      </b-col>
      <b-col md="7">
        <croppa
          v-model="croppaFoto"
          :width="420"
          :height="380"
          placeholder="Foto Comprobante"
          placeholder-color="#543338"
          :placeholder-font-size="16"
          canvas-color="transparent"
          :show-remove-button="true"
          remove-button-color="black"
          :show-loading="false"
          :loading-size="50"
          loading-color="#606060"
          :quality="1"
          class="mt-1"
          :initial-image="dataPago.foto_pago"
        ></croppa>
      </b-col>
    </b-row>

    <template #modal-footer>
      <span style="display:none">{{dataPago.new}}</span>
      <div class="w-100" v-if="dataPago.new">
        <template v-if="!showLoading">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="uploadNoticia"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
          <span>Espere..</span>
        </div>
        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px ;z-index:100"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BModal,
  BForm,
  BFormInput,
  BFormGroup,
  //   BFormInvalidFeedback,
  //   BFormValidFeedback,
  BFormTextarea,
  // BFormRadio,
  // BFormFile,
  BButton,
  BSpinner,
  BAlert,
  BRow,
  BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightFade } from '@core/directives/animations'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import {
  URL,
  USER,
  ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    // BFormInvalidFeedback,
    // BFormValidFeedback,
    BFormTextarea,
    // BFormRadio,
    // BFormFile,
    BButton,
    BSpinner,
    BAlert,
    flatPickr,
    vSelect,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
    heightFade,
  },
  props: {
    dataPago: Object,
    listResponsables: Array,
  },
  setup(props, { emit }) {
    const tieneErrorTitulo = ref(null)
    const mensajeErrorTitulo = ref('')
    const selected = ref(null)
    const inputTitulo = ref('')
    const croppaFoto = ref({})
    const file = ref(false)
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    const variante = ref('danger')
    const showLoading = ref(false)
    const hasError = ref(false)
    const fileModel = ref(null)
    const capturada = ref(false)
    const { postApiFormData } = apiCall()
    const dataNoticia = ref({
      titulo: '',
      link: '',
      descripcion: '',
      es_video: 'n',
      id_torneo: '0',
    })

    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function getPicturePlayer(croppa) {
      let fotografia = ''
      if (croppa.value.chosenFile == null) {
        fotografia = ''
      } else {
        const fotografiaBase64 = croppa.value.generateDataUrl(
          'image/jpeg',
          // eslint-disable-next-line
          0.7
        )
        fotografia = fotografiaBase64
      }
      return fotografia
    }
    function resetForm() {
      dataNoticia.value = {
        titulo: '',
        link: '',
        descripcion: '',
        es_video: 'n',
        id_torneo: '0',
      }
      capturada.value = false
      fileModel.value = null
      const canvas = document.getElementById('canvasFotoVideo')
      if (canvas != null) {
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
        const videoNode = document.querySelector('video')
        videoNode.src = null
      }
      selected.value = null
    }
    function errorTipo() {
      let error = false
      const foto64 = getPicturePlayer(croppaFoto)
      if (foto64 === '') {
        showMessageAlert(
          'danger',
          // eslint-disable-next-line
          'Seleccione una fotografía del comprobante'
        )
        error = true
      }
      return error
    }
    function hasErrorForm() {
      let error = false
      // console.log(props.dataPago)
      if (
        props.dataPago.valor === '' ||
        props.dataPago.valor === 0 ||
        props.dataPago.valor === null
      ) {
        showMessageAlert('danger', 'Valor no debe ser vacío o cero')
        error = true
      } else if (props.dataPago.fecha === '' || props.dataPago.fecha === null) {
        showMessageAlert('danger', 'Fecha no debe ser vacío')
        error = true
      } else if (props.dataPago.responsable.value === null) {
        showMessageAlert('danger', 'Debe seleccionar un responsable')
        error = true
      } else if (errorTipo()) {
        error = true
      }
      return error
    }
    async function uploadNoticia() {
      if (!hasErrorForm()) {
        showLoading.value = true
        const archivo = new FormData()
        archivo.append('valor', props.dataPago.valor)
        archivo.append('comprobante', props.dataPago.comprobante)
        archivo.append('descripcion', props.dataPago.descripcion)
        archivo.append('fecha', props.dataPago.fecha)
        archivo.append('id_campeonato', props.dataPago.id_campeonato)
        archivo.append('id_responsable', props.dataPago.responsable.value)
        archivo.append('nuevo_responsable', props.dataPago.responsable.label)
        archivo.append('fotografia', getPicturePlayer(croppaFoto))
        // console.log(archivo)
        const path = 'ApiConfiguration/savePago'
        const response = await postApiFormData(URL, path, archivo)
        if (response.flag === 'si') {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'GUARDADA con éxito',
                icon: 'AlertCircleIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'bottom-center',
              // eslint-disable-next-line
            }
          )
          emit('recargar')
          resetForm()
        } else {
          showMessageAlert(
            'danger',
            // eslint-disable-next-line
            'El responsable ya esta registrado, seleccionalo unicamente'
          )
        }
        showLoading.value = false
      }
    }

    function capturaPortada() {
      const canvas = document.getElementById('canvasFotoVideo')
      const video = document.getElementById('video')
      canvas
        .getContext('2d')
        .drawImage(video, 0, 0, canvas.width, canvas.height)
      capturada.value = true
    }

    function cambioFile(evt) {
      const tgt = evt.target || window.event.srcElement
      //   const file = tgt.files[0]
      // console.log(tgt.files.length)
      if (tgt.files.length === 0) {
        file.value = false
        const canvas = document.getElementById('canvasFotoVideo')
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
        const videoNode = document.querySelector('video')
        videoNode.src = null
        capturada.value = false
      } else {
        // eslint-disable-next-line
        file.value = true
        const videoNode = document.querySelector('video')
        const fileURL = window.URL.createObjectURL(tgt.files[0])
        videoNode.src = fileURL
      }

      //   function saveNew() {}
      //   console.log('tgt', tgt.files)
    }
    function onlyClose() {
      //   store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', false)
      showLoading.value = false
    }
    return {
      tieneErrorTitulo,
      mensajeErrorTitulo,
      inputTitulo,
      uploadNoticia,
      selected,
      croppaFoto,
      cambioFile,
      file,
      capturaPortada,
      dismissCountDown,
      dismissSecs,
      countDownChanged,
      messageError,
      variante,
      showLoading,
      hasError,
      showMessageAlert,
      dataNoticia,
      onlyClose,
      fileModel,
      USER,
      ROLES,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
</style>
